import ListProcesses from "@/views/agro_exporter/finances/container_incomes/ListProcesses.vue";
import ShowProcess from "@/views/agro_exporter/finances/container_incomes/ShowProcess.vue";
import ShowProcessContainers from "@/components/views/agro_exporter/finances/container_incomes/show_process/Containers.vue";
import ShowProcessExportInvoices from "@/components/views/agro_exporter/finances/container_incomes/show_process/ExportInvoices.vue";
import ShowContainer from "@/views/agro_exporter/finances/container_incomes/ShowContainer.vue";
import ShowExportInvoice from "@/views/agro_exporter/finances/container_incomes/ShowExportInvoice.vue";
import NewExportInvoice from "@/views/agro_exporter/finances/container_incomes/NewExportInvoice.vue";
import EditExportInvoice from "@/views/agro_exporter/finances/container_incomes/EditExportInvoice.vue";
import NewInvoicePayment from "@/views/agro_exporter/finances/container_incomes/NewInvoicePayment.vue"
import EditInvoicePayment from "@/views/agro_exporter/finances/container_incomes/EditInvoicePayment.vue"

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "ae",
  role: "finances",
  permission: "container_incomes"
});

export default [
  {
    path: "/ae/:agro_exporter_id/finances/container_incomes/list_processes",
    name: routeName(""),
    redirect: { name: routeName("list_processes") }
  },
  {
    path: "/ae/:agro_exporter_id/finances/container_incomes/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/finances/container_incomes/show_process/:agro_exporter_process_id",
    name: routeName("show_process"),
    redirect: { name: routeName("show_process_containers") },
    component: ShowProcess,
    props: true,
    meta: META,
    children: [
      {
        path: "containers",
        name: routeName("show_process_containers"),
        alias: "",
        component: ShowProcessContainers,
        props: true
      },
      {
        path: "export_invoices",
        name: routeName("show_process_export_invoices"),
        alias: "",
        component: ShowProcessExportInvoices,
        props: true
      }
    ]
  },
  {
    path: "/ae/:agro_exporter_id/finances/container_incomes/:agro_exporter_process_id/show_container/:container_id",
    name: routeName("show_container"),
    component: ShowContainer,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/finances/container_incomes/:agro_exporter_process_id/show_export_invoice/:export_invoice_id/:container_id",
    name: routeName("show_export_invoice"),
    component: ShowExportInvoice,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/finances/container_incomes/:agro_exporter_process_id/new_export_invoice/:container_id",
    name: routeName("new_export_invoice"),
    component: NewExportInvoice,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/finances/container_incomes/:agro_exporter_process_id/edit_export_invoice/:export_invoice_id",
    name: routeName("edit_export_invoice"),
    component: EditExportInvoice,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/finances/container_incomes/:agro_exporter_process_id/new_invoice_payment/:export_invoice_id",
    name: routeName("new_invoice_payment"),
    component: NewInvoicePayment,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/finances/container_incomes/:agro_exporter_process_id/edit_invoice_payment/:export_invoice_id/:invoice_payment_id",
    name: routeName("edit_invoice_payment"),
    component: EditInvoicePayment,
    props: true,
    meta: META
  }
];
